import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftActionsButtons,
  CftTank,
  CftLeavingModal,
  CftExportData,
} from "../../components";
import routes from "../../utils/cftRoutes";
import useCftChickenBroilerValues from "../../utils/useCftChickenBroilerValues";
import "../styles/progressDashboard.scss";
import { ChickenBroilerCoopForm } from "../../forms/chickenBroiler";

export default function ChickenBroilerPage() {
  const { t } = useTranslation(["cftChickenBroiler"]);
  const history = useHistory();
  const [showLeavingModal, setShowLeavingModal] = useState(false);
  const { store } = useCftChickenBroilerValues();
  const stopOverflow = () => {
    document.querySelector("body").style.overflowY = "hidden";
    document.querySelector("html").style.overflow = "hidden";
  };

  return (
    <CftLayout
      style={{ marginTop: 0 }}
      header={
        <CftHeader
          cropName={t("cftChickenBroiler:tag", "")}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportData type="chicken" />
              <CftActionsButtons.CancelButton
                hasText={false}
                onClick={() => {
                  stopOverflow();
                  setShowLeavingModal(!showLeavingModal);
                }}
              />
            </CftTank>
          }
        />
      }
    >
      <CftSection withNoSpace style={{ paddingTop: "7rem" }}>
        <ChickenBroilerCoopForm />
      </CftSection>
      <CftLeavingModal
        isVisible={showLeavingModal}
        hide={() => setShowLeavingModal(!showLeavingModal)}
        type="bothCalc"
        goToProfile={() => history.push(routes.MAIN)}
        dataReport={JSON.stringify(store)}
      />
    </CftLayout>
  );
}
